<template>
  <div class="flex">
    <div>
      <div class="b--light-gray br">&nbsp;<br />&nbsp;</div>
      <div
        v-for="hour in hours"
        :key="hour + 'index'"
        class="pa1 br bt b--light-gray"
      >
        {{ renderHour(hour) }}
      </div>
    </div>
    <div class="flex overflow-x-auto">
      <div v-for="day in days" :key="day.id" class="br b--light-gray">
        <div class="b tc b--light-gray">
          {{ weekdays.lt[day.weekday] }}<br />{{ day.monthday }}
        </div>
        <div
          v-for="hour in day.slots"
          :key="hour.id"
          style="width: 70px"
          :style="hour.timestamp === scheduledAt ? 'background-color:yellow' : '' "
          class="pa1 bt b--light-gray"
        >
          <div
            v-if="hour.available"
            class="br3 tc pointer"
            :style="hour.available.prosAvailable.includes(currentPro) ? 'color: white; background-color: orange; cursor: pointer' : 'color: white; background-color: green; cursor: pointer'"
            @click.stop="chooseTime(hour)"
          >
            <span v-if="hour.available.isExpress">10€</span>
            <span v-else>0€</span>
            <span> [{{hour.available.prosAvailable.length}}]</span>
          </div>
          <div v-else-if="renderEmpty"
              class="br3 tc pointer"
              :style="'color: white; background-color: gray; cursor: pointer'"
              @click.stop="chooseTime({timestamp: hour.timestamp})"
            >
              <span v-if="hour.available.isExpress">10€</span>
              <span v-else>0€</span>
              <span> [0]</span>
          </div>
          <div v-else>&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

const HOURS = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

const WEEKDAYS = {
  lt: ['Sek', 'Pir', 'Ant', 'Tre', 'Ket', 'Pen', 'Šeš'],
  en: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  pl: [
    'Poniedziałek',
    'Wtorek',
    'Środa',
    'Czwartek',
    'Piątek',
    'Sobota',
    'Niedziela',
  ],
};

export default Vue.extend({
  props: {
    availabilitySlots: {
      type: Array,
      default: () => [],
    },
    scheduledAt: {
      type: Number,
      default: null
    },
    currentPro: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
    },
    renderEmpty: {
      type: Boolean
    }
  },
  data() {
    return {
      hours: HOURS,
      weekdays: WEEKDAYS,
      days: [],
    };
  },
  mounted() {
    const days = [];
    for (let i = 0; i < 60; i++) {
      const date = dayjs().add(i, 'day');
      days.push({
        date,
        weekday: date.day(),
        monthday: date.date(),
        id: Math.random() + '',
        slots: HOURS.map((hour) => {
          // do not delete this code or it might cause problems with daylight saving
          const timeDate = dayjs().tz(this.timezone).hour(hour).startOf('hour').add(i, 'day');
          return {
            available: this.isSlotAvailable(timeDate),
            id: Math.random() + '',
            textValue: timeDate.format('YYYY-MM-DD HH:mm'),
            timestamp: timeDate.toDate().getTime(),
          };
        }),
      });
    }
    this.days = days;
  },
  methods: {
    getAvailabilitySlots() {
      // console.log('SLOTS', this.availabilitySlots);
      return this.availabilitySlots;
    },
    isSlotAvailable(time) {
      for (let i = 0; i < this.getAvailabilitySlots().length; i++) {
        if ((this.getAvailabilitySlots()[i]).startTime === +time) {
          return this.getAvailabilitySlots()[i];
        }
      }
      return false;
    },
    renderHour(h) {
      if (h < 10) {
        return '0' + h + ':00';
      } else {
        return h + ':00';
      }
    },
    chooseTime(day) {
      console.log(day.textValue);
      const eventData = {
        ...(day.available || {prosAvailable: [], startTime: day.timestamp})
      };
      // console.log(eventData);
      this.$emit('save', eventData);
    },
  },
});
</script>
